import { Calendar } from 'lucide-react';

export type DashboardRange = '7d' | '14d' | 'all';

interface DashboardRangeFilterProps {
  value: DashboardRange;
  onChange: (range: DashboardRange) => void;
  labels: {
    range7d: string;
    range14d: string;
    rangeAll: string;
    ariaLabel: string;
  };
}

const RANGES: ReadonlyArray<DashboardRange> = ['7d', '14d', 'all'];

export const DashboardRangeFilter = ({
  value,
  onChange,
  labels,
}: DashboardRangeFilterProps) => {
  const labelMap: Record<DashboardRange, string> = {
    '7d': labels.range7d,
    '14d': labels.range14d,
    all: labels.rangeAll,
  };
  return (
    <div
      role="radiogroup"
      aria-label={labels.ariaLabel}
      className="inline-flex items-center gap-1 rounded-[var(--radius-button)] p-1"
      style={{
        background: 'var(--surface-1)',
        border: '1px solid var(--divider-strong)',
      }}
      data-testid="dashboard-range-filter"
    >
      <Calendar
        className="ml-1.5 mr-0.5 h-3.5 w-3.5"
        style={{ color: 'var(--content-muted)' }}
        aria-hidden="true"
      />
      {RANGES.map((r) => {
        const selected = r === value;
        return (
          <button
            key={r}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(r)}
            className="rounded-[var(--radius-button)] px-3 py-1 text-[12px] font-medium transition-all focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)]"
            style={{
              background: selected ? 'var(--surface-raised)' : 'transparent',
              color: selected ? 'var(--content-strong)' : 'var(--content-muted)',
              boxShadow: selected ? 'var(--shadow-card-rest)' : 'none',
            }}
            data-testid={`dashboard-range-${r}`}
          >
            {labelMap[r]}
          </button>
        );
      })}
    </div>
  );
};
